import { useTranslation } from "react-i18next";
import {
  FormSectionWrapper,
  WelcomeSection,
  WelcomeSubtitle,
  WelcomeTitle,
} from "./stylex";
import FormInputs from "./formInputs";
import { Container } from "@mui/material";

export default function FormSection() {
  const { t } = useTranslation();
  return (
    <FormSectionWrapper>
      <Container maxWidth="sm">
        <WelcomeSection>
          <WelcomeTitle>{t("Signup.welcomeToMsool")}</WelcomeTitle>

          <WelcomeSubtitle>{t("Signup.createNewAccount")}</WelcomeSubtitle>
        </WelcomeSection>
        <FormInputs />
      </Container>
    </FormSectionWrapper>
  );
}
